import type { Settings, WMSInfo } from '@ais-ui/websockets';
import type { CollectionTranslator } from '../types';

/**
 * Translator for the `wms` collection. Unlike the other collections, wms is
 * **blob-read-only**: the legacy blob's `wmsSettings[]` (`WMSInfo`) is the
 * lossless source of truth and stays the read source, because
 *
 *  - the service list endpoint returns a lossy summary (no `selected[]`), and
 *  - `selected[]` is consumed by `olserver` (Bucket A) so the blob must stay
 *    authoritative and complete.
 *
 * We therefore pass the rich `WMSInfo` through unchanged (id-stable), writing it
 * back to the blob losslessly and dual-writing the same object to the service
 * (whose model allows extra fields) so the service is kept in sync for a later
 * cutover — without ever narrowing the blob to the backend's trimmed shape.
 */
export const wmsTranslator: CollectionTranslator<WMSInfo> = {
  fromBlob(blob: Settings): WMSInfo[] {
    const services = (blob as unknown as Record<string, unknown>).wmsSettings;
    return Array.isArray(services) ? (services as WMSInfo[]) : [];
  },

  applyToBlob(blob: Settings, items: WMSInfo[]): Settings {
    return {
      ...(blob as unknown as Record<string, unknown>),
      wmsSettings: items,
    } as unknown as Settings;
  },
};
